import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Image, Typography } from 'antd';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import RocketlaneLogoSvg from 'assets/svgs/rocketlane_logo_full.svg';
import { ProductiveHeading03 } from 'components/styles';
const Center = styled.div`
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: start;
  padding: var(--spacing-08) var(--spacing-11);
`;
const Wrapper = styled.div`
  width: 520px;
`;
const ItemWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding-bottom: var(--spacing-09);
`;
const ImageWrapper = styled.div`
  margin-bottom: var(--spacing-10);
`;
const StyledTitle = styled(Typography.Title)`
  ${ProductiveHeading03};
  font-weight: var(--heading-4-weight);
  margin: 0;
  font-size: var(--heading-3-size);
`;
export const MultipleAccounts = ({ email })=>{
    return /*#__PURE__*/ _jsx(Center, {
        children: /*#__PURE__*/ _jsxs(Wrapper, {
            children: [
                /*#__PURE__*/ _jsxs(ItemWrapper, {
                    children: [
                        /*#__PURE__*/ _jsx(ImageWrapper, {
                            children: /*#__PURE__*/ _jsx(Image, {
                                width: 160,
                                src: RocketlaneLogoSvg,
                                alt: "Rocketlane",
                                preview: false
                            })
                        }),
                        /*#__PURE__*/ _jsx(StyledTitle, {
                            children: /*#__PURE__*/ _jsx(FormattedMessage, {
                                id: "account_setup_multiple.accounts.header",
                                values: {
                                    email,
                                    strong: (chunks)=>/*#__PURE__*/ _jsx("strong", {
                                            children: chunks
                                        })
                                }
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx(ItemWrapper, {
                    children: /*#__PURE__*/ _jsx(StyledTitle, {
                        children: /*#__PURE__*/ _jsx(FormattedMessage, {
                            id: "account_setup_multiple.accounts.body"
                        })
                    })
                }),
                /*#__PURE__*/ _jsx(ItemWrapper, {
                    children: /*#__PURE__*/ _jsx(FormattedMessage, {
                        id: "account_setup_multiple.accounts.footer"
                    })
                })
            ]
        })
    });
};
